<div class="card-link mt-2 mx-auto">
    <a [href]="linkPreview.url"
       class="card-link-preview"
       target="_blank">
        @if(linkPreview.image){
        <div class="preview-image">
            <img [src]="linkPreview.image"
                 [alt]="linkPreview.title" />
        </div>
        }
        @if(linkPreview.title || linkPreview.description){
        <div class="preview-content">
            <div class="preview-title">{{ linkPreview.title }}</div>
            <div class="preview-description">{{ linkPreview.description }}</div>
        </div>
        }
    </a>
</div>